interface GoodPractice {
    id: number;
    companyId: number;
    title: string;
    description: string | null;
    isPublic: boolean;
    userId: number;
    itemCategory: any;
}

const EmptyGoodPractice: GoodPractice = {
    id: 0,
    companyId: 0,
    title: '',
    description: null,
    isPublic: false,
    userId: 0,
    itemCategory: { name : '' }
};

export { EmptyGoodPractice };

export default GoodPractice;
